/* eslint-disable @altermaind/no-magic-numbers */
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { Box, Typography } from '@altermaind/web/ui';

const COLORS = ['#3A0CE8', '#B084F7', '#EF5350'];

type Props = {
  data: { name: string; value: number }[];
};

export const PieChartComponent = ({ data }: Props) => {
  if (data) {
    return (
      <>
        <ResponsiveContainer width='100%' height={300}>
          <PieChart>
            <Pie
              data={data}
              cx='50%'
              cy='50%'
              innerRadius={90}
              outerRadius={110}
              paddingAngle={0}
              cornerRadius={20}
              dataKey='value'
              style={{ cursor: 'pointer' }}
            >
              {data.map((entry, index) => (
                <Cell key={entry.name} fill={COLORS[index % COLORS.length]} stroke='none' />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => {
                const total = data.reduce((sum, entry) => sum + entry.value, 0);
                const currentValue = value as number;
                const currentPercent = total > 0 ? ((currentValue / total) * 100).toFixed(0) : '0';
                return [`${currentValue} crediti (${currentPercent}%)`, name];
              }}
              contentStyle={{
                backgroundColor: '#fff',
                color: '#000',
                borderRadius: '8px',
                padding: '6px 10px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
                fontSize: '14px',
                border: 'none',
              }}
            />
          </PieChart>
        </ResponsiveContainer>
        <Box justifyContent='center' width='100%' display='flex' flexDirection='row'>
          {data.map((entry, index) => (
            <Box alignContent='center' key={entry.name} display='flex' alignItems='center' mr='m'>
              <Box
                width='xxs'
                height='xxs'
                backgroundColor={COLORS[index % COLORS.length] as never}
                borderRadius='50%'
                mr='xxxs'
              />
              <Typography variant='p2/light'>
                {entry.name}: {entry.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </>
    );
  }

  return null;
};
